import React from 'react';

import Modal, { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/cirrus-modal';
import { Button } from '@lightspeed/flame/Button';

export default class FirstTimeModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      downloadTemplateUrl: '',
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    const accountID = window.merchantos.session.getSystemCustomerID();

    window.lsCloud
      .startServerJob(
        {
          url: `/API/Account/${accountID}/ItemImport/Template`,
          type: 'GET',
        },
        false
      )
      .done((data) => {
        const downloadTemplateUrl = `data:text/plain;charset=utf-8,${encodeURIComponent(data)}`;

        this.setState({
          downloadTemplateUrl,
          showModal: true,
        });
      });
  }

  handleClose() {
    this.setState({
      showModal: false,
    });

    this.props.renderedComponent.unmount();
  }

  render() {
    const { showModal, downloadTemplateUrl } = this.state;
    return (
      <Modal className="import cirrus" isOpen={showModal} onRequestClose={this.handleClose}>
        <ModalHeader onCloseClicked={this.handleClose}>Welcome to Import Items!</ModalHeader>
        <ModalBody className="modal-container">
          <div className="cr-text-center">
            <img
              src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-118c0e2/images/item_import/first-time.png"
              title="first-time"
              style={{ maxWidth: '650px' }}
              className="cr-mb-6"
              alt=""
            />
          </div>
          <h1>Some things to know before starting: </h1>
          <div className="cr-text-s">
            <p className="cr-m-0">
              Import Items uses your data to
              <strong> create new items and update fields on existing items. </strong>
            </p>
            <p className="cr-m-0">
              <strong>Create up to 1000 items </strong>
              per import.
            </p>
            <p className="cr-m-0">Item data must be formatted as a CSV, XLS, or XLSX file.</p>
            <p className="cr-m-0">
              <a
                download="item_import_sample.csv"
                id="import-help-modal-csv-template-download"
                href={downloadTemplateUrl}
              >
                Download a template CSV
              </a>{' '}
              to get kick-started on the preferred data format.
            </p>
          </div>
        </ModalBody>
        <ModalFooter className="cr-flex cr-justify-between">
          <Button
            onClick={() => {
              window.open('https://retail-support.lightspeedhq.com/hc/en-us/sections/115000406787');
            }}
            variant="secondary"
          >
            Go to Import Help
          </Button>
          <Button id="item-import-help-model-close-button" onClick={this.handleClose}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
